@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@width: 300px;

.rate-viewer-modal {
  width: 1000px;
  height: 860px;

  .left-side-wrapper {
    background: @rate-browser-modal-form--background-color;
    width: @width;
    min-width: @width;
    border-right: 1px solid @rate-browser-modal-form--border-color;
    position: relative;
  }

  .rate-list-wrapper {
    display: flex;
    align-items: stretch;
    height: 100%;
    width: calc(100% - @width);
    position: relative;
  }
}

.rate-viewer-modal-body {
  display: flex;
  height: 100%;
}

.multi-package-warning {
  padding-top: 5px;
  padding-left: 5px;
  display: flex;
  align-items: center;
  font-size: 13px;
}

.icon {
  padding: 7px;
}
